import React from "react"
import Navbar from "../components/Navbar"
import Hero from "../components/Hero"
import Projects from "../components/Projects"
import Footer from "../components/Footer"
import Sidebar from "../components/Sidebar"
import {useState} from "react"
import About from "../components/About"
import Contact from "../components/Contact"
import { Helmet } from "react-helmet"

export default function Home() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }
  return (
    <>
    <Helmet>
          <meta charSet="utf-8" />
          <title>Shreyank Singhal</title>
        </Helmet>
      <Navbar toggleSidebar={toggleSidebar}/>
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar}/>
      <Hero/>
      <About/>
      <Projects/>
      <Contact/>
      <Footer/>
    </>
  )
}
